var exports = {
  "kL": "x2b2fbebb--f675e9--container",
  "Pf": "x2b2fbebb--f675e9--label",
  "O0": "x2b2fbebb--f675e9--rating",
};

module.exports = exports;
